export default function _AwaitValue(value) {
  this.wrapped = value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/core/node_modules/@babel/runtime/helpers/esm/AwaitValue.js
// module id = 597
// module chunks = 0